export const PARTNER_SERVICE_CONFIG = [
  { key: 'driver', label: 'Taxi Drivers', userType: 'driver', hubType: 'transport', formCode: 'driver_onboarding' },
  { key: 'delivery_partner', label: 'Delivery Partners', userType: 'delivery_partner', hubType: 'delivery', formCode: 'delivery_partner_onboarding' },
  { key: 'service_provider', label: 'Service Providers', userType: 'service_provider', hubType: 'on_demand', formCode: 'service_provider_onboarding' },
] as const;

export const PARTNER_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'verified', label: 'Verified', color: 'success' as const },
  { value: 'non_verified', label: 'Non Verified', color: 'warning' as const },
  { value: 'pending_approval', label: 'Pending Approval', color: 'info' as const },
  { value: 'blocked', label: 'Blocked', color: 'error' as const },
  { value: 'deleted', label: 'Deleted', color: 'default' as const },
  { value: 'expired', label: 'Expired', color: 'error' as const },
];

export const SERVICE_HUB_OPTIONS = [
  { value: 'transport', label: 'Transport' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'on_demand', label: 'On Demand' },
];

export function getPartnerConfig(entityType: string) {
  return PARTNER_SERVICE_CONFIG.find((c) => c.key === entityType);
}

export const PARTNER_ENTITY_TYPES = PARTNER_SERVICE_CONFIG.map((c) => c.key);

export function isPartnerEntityType(entityType: string): boolean {
  return PARTNER_ENTITY_TYPES.includes(entityType as typeof PARTNER_ENTITY_TYPES[number]);
}

/** Singular label for create buttons and drawer titles (e.g. "Taxi Driver"). */
export function getPartnerCreateLabel(entityType: string): string {
  const labels: Record<string, string> = {
    driver: 'Taxi Driver',
    delivery_partner: 'Delivery Partner',
    service_provider: 'Service Provider',
  };
  return labels[entityType] || getPartnerConfig(entityType)?.label.replace(' Onboarding', '') || 'Partner';
}

/** Assigned service hub for admin-created partners (create form — hub is not user-selectable). */
export function getPartnerAssignedHub(entityType: string): string {
  return getPartnerConfig(entityType)?.hubType || 'transport';
}
